// Product brief for Lincoln MoneyGuard Fixed Advantage. See cmTwo.ts for format.

export const lincolnMoneyGuardBrief = `**Lincoln MoneyGuard Fixed Advantage** — asset-based hybrid UL with an LTC
benefits rider (LTCBR). Same broad two-pool, face-first shape as OneAmerica
Asset Care, with Lincoln's own indemnity cap.

Pool model — two pools, drawn in order:
- **Face / Specified Amount** is the \`base_pool\`, drawn FIRST. On this product
  the Face is the death benefit and the at-issue LTC acceleration portion. If
  LTCBR inflation fields are present, LTC pool/cap growth follows the header
  rates while the death benefit remains flat. Prior utilization is subtracted at
  init.
- **Continuation of Benefits (COB)** is the \`eob\` column, drawn only after the
  Face pool is exhausted.

Death benefit:
- **Flat Face — never inflated.** LTC reimbursements reduce the death benefit
  dollar-for-dollar by the **Face (base) drawdown only**; COB drawdown does NOT
  reduce it. Floored at the Residual DB (minimum guaranteed, ~5% of Face).
  Remaining DB at the horizon is a non-LTC return.

Payout model — reimbursement (default) or cash indemnity:
- **Reimbursement** (default): pays min(eligible cost, pro-rated cap), drawing
  Face then COB.
- **Indemnity** (first-claim election): pays cash from the Face pool regardless
  of actual cost, capped by \`policyIndemnityBenefitPercent\` (80% on the mapped
  MoneyGuard illustration). Once Face is exhausted, the strategy falls back to
  reimbursement on COB.

Elimination period:
- **No retroactive WP lump.** Elimination-period days are out-of-pocket.

Things to eyeball:
- Face depletes before any COB drawdown — \`eob\` stays flat until \`base_pool\` is 0.
- Indemnity rows pay 80% of the pro-rated cap when the MoneyGuard cap is present.
- Death benefit falls only with Face drawdown, never with COB, and never inflates.
- DB stops falling once it reaches the residual floor.
`;
